import { Component, inject } from '@angular/core';
import { ZenithComponentsModule } from '@mateco/zenith-webcomponents-angular/dist/zenith-webcomponents-angular';
import { TranslateModule } from '@ngx-translate/core';
import { LogoutService } from '../../../../services/logout.service';

@Component({
  selector: 'app-unauthorized',
  template: `
    <zenith-card class="m-3" zn-mobile-full-width>
      <zenith-card-content>
        <div class="zn-row">
          <div class="zn-col-1 zn-col-sm-1 zn-col-md-2 zn-col-lg-3"></div>
          <div class="zn-text-align-center zn-col-10 zn-col-sm-10 zn-col-md-8 zn-col-lg-6">
            <img src="assets/images/unauthorized.svg" alt="unauthorized" height="300" />

            <h1>
              {{ 'components.unauthorized.title' | translate }}
            </h1>
            <p>
              {{ 'components.unauthorized.message' | translate }}
            </p>

            <zenith-button
              zn-appearance="primary"
              (click)="logout()">{{ 'components.unauthorized.logout' | translate }}
            </zenith-button>
          </div>
          <div class="zn-col-1 zn-col-sm-1 zn-col-md-2 zn-col-lg-3"></div>
        </div>
      </zenith-card-content>
    </zenith-card>
  `,
  imports: [ZenithComponentsModule, TranslateModule],
  standalone: true
})
export class UnauthorizedComponent {
  private readonly logoutService = inject(LogoutService);

  logout() {
    this.logoutService.logout().subscribe();
  }
}
